
import ProblemVa from "@/components/modal/ProblemVa.vue";
import UnfoundVa from "@/components/modal/UnfoundVa.vue";
import StepBar from "@/components/stepBar/StepBar.vue";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    StepBar,
    ProblemVa,
    UnfoundVa,
  },
  data() {
    return {
      showProblemModal: false,
      showUnfoundModal: false,
      vaFirstName: "",
      vaLastName: "",
      vaNumber: "",
      lastVaId: -1,
      previousVaExists: false,
      updatePreviousVa: false,
      VA: true,
    };
  },
  methods: {
    onChange(event: Event) {
      if (event.target) {
        if (
          (event.target as HTMLInputElement).id &&
          (event.target as HTMLInputElement).id === "yesRadioButton"
        ) {
          this.VA = true;
        } else {
          this.VA = false;
        }
      }
    },
    next() {
      this.$store.dispatch("user/setMe");
      this.$router.push({ name: "RegisterCertificate" });
    },
    sendVa() {
      if (this.previousVaExists) {
        this.updateVa();
      } else {
        this.createVa();
      }
    },
    async createVa() {
      const vaCheckResponse = await axios.post("/checkVA", {
        vaNumber: this.vaNumber,
        vaFirstName: this.vaFirstName,
        vaLastName: this.vaLastName,
      });

      if (vaCheckResponse.status === 200) {
        return this.next();
      }

      this.toggleUnfoundModal();
    },
    async findPreviousVa() {
      const lastVa = await axios.get("vas/me/last");
      if (lastVa.status >= 300) {
        return;
      }

      this.previousVaExists = true;
      this.vaFirstName = lastVa.data.inscription.athlete.firstName;
      this.vaLastName = lastVa.data.inscription.athlete.lastName;
      this.vaNumber = lastVa.data.va;
      this.lastVaId = lastVa.data.id;
    },
    async updateVa() {
      const vaResponse = await axios.put("vas/" + this.lastVaId, {
        vaNumber: this.vaNumber,
        vaFirstName: this.vaFirstName,
        vaLastName: this.vaLastName,
      });
      if (vaResponse.status === 200) {
        return this.next();
      }
      this.toggleUnfoundModal();
    },
    toogleUpdateVa() {
      this.updatePreviousVa = true;
      this.VA = true;
    },
    toggleProblemModal() {
      this.showProblemModal = !this.showProblemModal;
    },
    toggleUnfoundModal() {
      this.showUnfoundModal = !this.showUnfoundModal;
    },
  },
  beforeMount() {
    this.findPreviousVa();
  },
});
